var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6652 16.221C9.78016 16.221 8.52766 15.5985 7.53766 12.621L6.99766 11.001L5.37766 10.461C2.40766 9.47103 1.78516 8.21853 1.78516 7.33353C1.78516 6.45603 2.40766 5.19603 5.37766 4.19853L11.7452 2.07603C13.3352 1.54353 14.6627 1.70103 15.4802 2.51103C16.2977 3.32103 16.4552 4.65603 15.9227 6.24603L13.8002 12.6135C12.8027 15.5985 11.5502 16.221 10.6652 16.221ZM5.73016 5.27103C3.64516 5.96853 2.90266 6.79353 2.90266 7.33353C2.90266 7.87353 3.64516 8.69853 5.73016 9.38853L7.62016 10.0185C7.78516 10.071 7.92016 10.206 7.97266 10.371L8.60266 12.261C9.29266 14.346 10.1252 15.0885 10.6652 15.0885C11.2052 15.0885 12.0302 14.346 12.7277 12.261L14.8502 5.89353C15.2327 4.73853 15.1652 3.79353 14.6777 3.30603C14.1902 2.81853 13.2452 2.75853 12.0977 3.14103L5.73016 5.27103Z",
    fill: "#40196D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58211 10.8C7.43961 10.8 7.29711 10.7475 7.18461 10.635C6.96711 10.4175 6.96711 10.0575 7.18461 9.84L9.86961 7.1475C10.0871 6.93 10.4471 6.93 10.6646 7.1475C10.8821 7.365 10.8821 7.725 10.6646 7.9425L7.97961 10.635C7.87461 10.7475 7.72461 10.8 7.58211 10.8Z",
    fill: "#40196D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendOutline);
export default __webpack_public_path__ + "static/media/send-outline.d12cb94f0c70069ed0a2be8cebee37eb.svg";
export { ForwardRef as ReactComponent };